/**
 * DataIntel API Service
 * Handles all API calls for P5: DataIntel (Data Intelligence & Analytics)
 */
import apiClient from '../lib/apiClient';

/**
 * Get DataIntel product information
 */
export const getDataIntelInfo = async () => {
  const response = await apiClient.get('/dataintel/');
  return response.data;
};

/**
 * Get Canadian database statistics
 */
export const getCanadaStats = async () => {
  const response = await apiClient.get('/dataintel/database-stats/canada');
  return response.data;
};

/**
 * Get US database statistics
 */
export const getUSStats = async () => {
  const response = await apiClient.get('/dataintel/database-stats/us');
  return response.data;
};

/**
 * Get data pipeline status
 */
export const getPipelineStatus = async () => {
  const response = await apiClient.get('/dataintel/data-pipeline/status');
  return response.data;
};

export const getFunderOverview = async () => {
  const response = await apiClient.get('/dataintel/funders/overview');
  return response.data;
};

/**
 * Get aggregated competition density landscape (province + category breakdown).
 * Data from org_competition_landscape — 83K CA orgs, updated monthly.
 */
export const getCompetitionLandscape = async () => {
  const response = await apiClient.get('/dataintel/competition/landscape');
  return response.data;
};

/**
 * Get competition density for a specific org by BN number.
 * Returns mirror/direct/method_alt/indirect/adjacent counts + provincial benchmark.
 */
export const getOrgCompetitionDensity = async (bn) => {
  const response = await apiClient.get(`/dataintel/competition/org/${bn}`);
  return response.data;
};

/**
 * Get the full CF_Derived_Functions table (Context Frame × Situation, 36 rows).
 * Used by the Context Frame Engine for mission × situation pre-scoring.
 */
export const getCFDerivedFunctions = async () => {
  const response = await apiClient.get('/dataintel/cf/functions');
  return response.data;
};

